import { gsap } from "gsap/dist/gsap";

export default function handleHamburgerAnimation() {
  const hamburgerTl = new gsap.timeline({ paused: true });

  hamburgerTl
    .to(
      "#hamburger--line-1",
      {
        duration: 0.2,
        y: 0,
      },
      "center"
    )
    .to(
      "#hamburger--line-3",
      {
        duration: 0.2,
        y: 0,
      },
      "center"
    )
    .to(
      "#hamburger--line-3",
      {
        duration: 1,
        rotateZ: 90,
        ease: "elastic.out(1,0.3)",
      },
      "rotate"
    )
    .to(
      "#hamburger--inner-container",
      {
        duration: 1,
        rotateZ: 135,
        ease: "elastic.out(1,0.3)",
      },
      "rotate"
    );

  return hamburgerTl;
}
